import { render, staticRenderFns } from "./PostalAddressPickerDialog.vue?vue&type=template&id=6131f8a7&scoped=true&"
import script from "./PostalAddressPickerDialog.vue?vue&type=script&lang=ts&"
export * from "./PostalAddressPickerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PostalAddressPickerDialog.vue?vue&type=style&index=0&id=6131f8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6131f8a7",
  null
  
)

export default component.exports